<template>
  <div>
    <template>
      <el-form v-if="!drawer" :inline="true" style="z-index: 99999999">
        <el-row v-for="(r,i) in value" :key="r.uniqueId">
          <el-form-item label="道具" style="margin-top: 10px;margin-bottom: 12px!important;">
            <el-cascader v-model.number="r.propsId" size="small" :options="propsOption" :props="{ expandTrigger: 'hover',emitPath:false }" :show-all-levels="false" @change="(v)=>propChange(v,i)" />
          </el-form-item>
          <el-form-item :label="activityToTypeId.includes(r.propsId) || limitedSkinPropsId.includes(r.propsId) ? '时长' : '数量'" style="margin-top: 10px;margin-bottom: 12px!important;">
            <el-input v-model.number="r.num" size="small" :readonly="skinId.includes(r.propsId) " style="width: 90px;" placeholder="数量" />
          </el-form-item>
          <el-form-item style="margin-top: 10px;margin-bottom: 12px!important;" :label="handleExtraValTitle(r.propsId)">
            <el-select v-if="skinMap[r.propsId]" v-model="r.skin" size="small" placeholder="请选择" style="width: 120px">
              <el-option v-for="item in skinMap[r.propsId]" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
            <el-select v-else-if="activityToTypeId.includes(r.propsId)" v-model.number="r.skin" size="small" placeholder="请选择" style="width: 120px">
              <el-option v-for="item in activityList[r.propsId]" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
            <el-select v-else-if="r.propsId === 14" v-model.number="r.rtype" size="small" placeholder="请选择" style="width: 120px">
              <el-option v-for="item in money" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
            <el-select v-else v-model.number="r.skin" size="small" placeholder="扩展参数" :disabled="true" style="width: 120px">
              <el-option :key="0" label="扩展参数" :value="0" />
            </el-select>
          </el-form-item>
          <el-form-item style="margin-top: 10px;margin-bottom: 12px!important;">
            <el-button size="small" type="danger" @click="removeReward(i)">删除</el-button>
          </el-form-item>
          <span v-if="r.propsId === 65" style="display: block;color: #ff0000;font-size: small;padding-left: 2vw;">此处野兽币万进值,配置10000发1</span>
        </el-row>
        <el-form-item v-if="limitLen > value.length" style="margin-top:10px">
          <el-button size="small" type="primary" @click="addReward()">+</el-button>
        </el-form-item>
      </el-form>
    </template>
    <span v-if="!single && readOnly">{{ handleShowReward(value) }}</span>
    <el-button v-else-if="!single && drawer" type="text" style="margin-left: 16px;color: #606266" @click="showDrawer = true"><i class="el-icon-edit-outline" />&nbsp;&nbsp; {{ handleShowReward(value) }}</el-button>
    <el-drawer v-if="drawer" append-to-body title="奖励配置" :visible.sync="showDrawer" :with-header="true" size="35%" :modal-append-to-body="false">
      <template>
        <el-form :inline="true">
          <el-row v-for="(r,i) in value" :key="r.uniqueId">
            <el-form-item label="道具" style="margin-top: 10px;margin-bottom: 12px!important;">
              <el-cascader v-model.number="r.propsId" size="small" :options="propsOption" :props="{ expandTrigger: 'hover',emitPath:false }" :show-all-levels="false" @change="(v)=>propChange(v,i)" />
            </el-form-item>
            <el-form-item :label="activityToTypeId.includes(r.propsId) || limitedSkinPropsId.includes(r.propsId) ? '时长' : '数量'" style="margin-top: 10px;margin-bottom: 12px!important;">
              <el-input v-model.number="r.num" size="small" :readonly="skinId.includes(r.propsId) " style="width: 90px;" placeholder="数量" />
            </el-form-item>
            <el-form-item style="margin-top: 10px;margin-bottom: 12px!important;" :label="handleExtraValTitle(r.propsId)">
              <el-select v-if="skinMap[r.propsId]" v-model="r.skin" size="small" placeholder="请选择" style="width: 120px">
                <el-option v-for="item in skinMap[r.propsId]" :key="item.value" :disabled="limitVipSkinId.includes(r.propsId) && item.disabled" :label="item.label" :value="item.value" />
              </el-select>
              <el-select v-else-if="activityToTypeId.includes(r.propsId)" v-model.number="r.skin" size="small" placeholder="请选择" style="width: 120px">
                <el-option v-for="item in activityList[r.propsId]" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
              <el-select v-else-if="r.propsId === 14" v-model.number="r.rtype" size="small" placeholder="请选择" style="width: 120px">
                <el-option v-for="item in money" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
              <el-select v-else v-model.number="r.skin" size="small" placeholder="扩展参数" :disabled="true" style="width: 120px">
                <el-option :key="0" label="扩展参数" :value="0" />
              </el-select>
            </el-form-item>
            <el-form-item style="margin-top: 10px;margin-bottom: 12px!important;">
              <el-button size="small" type="danger" @click="removeReward(i)">删除</el-button>
            </el-form-item>
            <span v-if="r.propsId === 65" style="display: block;color: #ff0000;font-size: small;padding-left: 2vw;">此处野兽币万进值,配置10000发1</span>
          </el-row>

          <el-form-item v-if="limitLen > value.length" style="margin-top:10px">
            <el-button size="small" type="primary" @click="addReward()">+</el-button>
          </el-form-item>
        </el-form>
      </template>
    </el-drawer>
  </div>
</template>

<script>
import { getAnimalAllList, getShieldsAllList, getSieveAllList } from '@/api/config/area-cfg'
import { getRewardType } from '@/api/config/slot'
import { getChestCfgAll } from '@/api/config/chest-skin-cfg'
import { getActivityTypeToMap, getPropsActList } from '@/api/config/activity-cfg'
import { getAvatarCfgAll } from '@/api/config/avatar-cfg'
import { getCacheConfig } from '@/utils'
import { getBuildBoxAllCfg } from '@/api/config/blind-box-cfg'
import { comAuxiliary } from '@/api/config/activity-auxiliary-cfg'
import { pinata } from '@/api/config/api'
import { getChestPropCfgAll } from '@/api/config/chest-prop-cfg'

export default {
  name: 'Reward',
  props: {
    ucType: {
      type: Number,
      default: 1,
      required: false
    },
    exclude: {
      type: Array,
      default: () => [],
      required: false
    },
    excludeCate: { // 限制分类
      type: Array,
      default: () => [],
      required: false
    },
    value: {
      type: Array,
      default: () => ([]),
      required: false
    },
    limitLen: {
      type: Number,
      default: 999,
      required: false
    },
    limitType: {
      type: Array,
      default: () => [],
      required: false
    },
    drawer: {
      type: Boolean,
      default: true,
      required: false
    },
    readOnly: {
      type: Boolean,
      default: false,
      required: false
    },
    single: { // 不显示编辑图标
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      showDrawer: false,
      loading: false,
      money: [{ value: 1, label: '只取数量' }, { value: 2, label: '等级取值' }],
      chest: [],
      animal: [],
      shield: [],
      dice: [],
      avatar: [],
      rewardTypeMap: [],
      activityToType: [],
      activityToTypeId: [],
      activityList: {},
      skinMap: {},
      skinId: [],
      blindBox: [],
      randMoney: [],
      randSpins: [],
      randDiamond: [],
      randCooperativeCoin: [],
      pinata: [],
      propsOption: [
        { value: 100000, label: '等级金币', children: [], props: [14, 5001, 5002, 5003, 5004, 5005, 5006, 5007, 5008, 5009, 5010, 5011, 5012, 5013, 5014, 5015, 5016, 5017, 5018, 5019, 5020] },
        { value: 100001, label: '常规道具', children: [], props: [15, 16, 22, 37, 42, 65, 74, 82, 83, 89, 90, 109, 110, 111] },
        { value: 100002, label: '卡片道具', children: [], props: [1, 2, 3, 13, 79, 18, 107, 108] },
        { value: 100003, label: '皮肤道具', children: [], props: [19, 23, 71, 86, 62, 67, 68, 76, 77, 78, 101, 102, 103, 104, 105, 106] },
        { value: 100004, label: '活动道具', children: [], props: [25, 28, 31, 32, 36, 41, 53, 55, 72, 73, 75, 80, 81, 85, 88] },
        { value: 100005, label: '方块道具', children: [], props: [1002, 1003, 1004, 1005, 1006, 1007, 1008, 1009, 1010] }
      ],
      limitedSkinPropsId: [76, 77, 78],
      limitVipSkinId: [62, 67, 68]// vip 限制 棋子 野兽 盾牌
    }
  },
  watch: {
    value: function(newVal) {
      this.$emit('input', newVal)
    }
  },
  created() {
    this.initConfig()
    this.skinMap = {
      19: this.chest,
      23: this.avatar,
      62: this.animal,
      67: this.shield,
      68: this.dice,
      76: this.animal,
      77: this.shield,
      78: this.dice,
      71: this.blindBox,
      82: this.randMoney,
      83: this.randSpins,
      86: this.pinata,
      89: this.randDiamond,
      90: this.randCooperativeCoin,
      101: this.animal,
      102: this.shield,
      103: this.dice,
      104: this.animal,
      105: this.shield,
      106: this.dice
    }
    for (const propsId in this.skinMap) {
      const actionPropsId = parseInt(propsId)
      if (!this.limitedSkinPropsId.includes(actionPropsId)) {
        this.skinId.push(actionPropsId)
      }
    }
    if (this.excludeCate.length > 0) {
      const propsOption = []
      for (const i in this.propsOption) {
        const val = this.propsOption[i]
        if (this.excludeCate.includes(val.value)) {
          propsOption.push(this.propsOption[i])
        }
      }
      this.propsOption = propsOption
    }
  },
  methods: {
    setConfig(conf, data) {
      for (const i in data) {
        const list = { label: data[i].lang_key, value: parseInt(data[i].id), disabled: data[i].vip === 1 }
        if (data[i].vip === 1) {
          conf.push(list)
        } else {
          conf.unshift(list)
        }
      }
    },
    initConfig() {
      getCacheConfig(getRewardType, 'getRewardType' + this.ucType, { data: this.ucType }).then(res => {
        this.rewardTypeMap = res.data
        for (const i in res.data) {
          const propsId = parseInt(i)
          if (!this.exclude.includes(propsId)) {
            if (this.limitType.length > 0) {
              if (this.limitType.indexOf(propsId) < 0) {
                continue
              }
            }
            for (let j = 0; j < this.propsOption.length; j++) {
              if (this.propsOption[j].props.indexOf(propsId) >= 0) {
                this.propsOption[j].children.push({ label: res.data[i], value: propsId })
                break
              }
            }
          }
        }
      })
      getCacheConfig(getBuildBoxAllCfg, 'getBuildBoxAllCfg').then(res => {
        for (const i in res.data) {
          this.blindBox.push({ label: res.data[i].name, value: parseInt(res.data[i].id) })
        }
      })
      getCacheConfig(getAnimalAllList, 'getAnimalAllList').then(res => { this.setConfig(this.animal, res.data) })
      getCacheConfig(getShieldsAllList, 'getShieldsAllList').then(res => { this.setConfig(this.shield, res.data) })
      getCacheConfig(getSieveAllList, 'getDiceAllList').then(res => { this.setConfig(this.dice, res.data) })
      getCacheConfig(getChestCfgAll, 'getChestCfgAll').then(res => {
        for (const i in res.data) {
          this.chest.push({ label: res.data[i].name, value: parseInt(res.data[i].id) })
        }
      })
      getCacheConfig(getChestPropCfgAll, 'getChestPropCfgAll').then(res => {
        for (const i in res.data) {
          this.chest.push({ label: res.data[i].name, value: parseInt(res.data[i].id) })
        }
      })
      getCacheConfig(pinata, 'pinata').then(res => {
        for (const i in res.data) {
          this.pinata.push({ label: res.data[i].name, value: parseInt(res.data[i].id) })
        }
      })
      getCacheConfig(getAvatarCfgAll, 'getAvatarCfgAll').then(res => {
        for (const i in res.data) {
          this.avatar.push({ label: res.data[i].name, value: parseInt(res.data[i].avatar_id) })
        }
      })
      getCacheConfig(getActivityTypeToMap, 'getActivityTypeToMap').then(res => {
        this.activityToType = res.data
        for (const i in res.data) {
          const type = parseInt(i)
          this.activityToTypeId.push(type)
          this.activityList[type] = []
        }
        getCacheConfig(getPropsActList, 'getPropsActList').then(ret => {
          for (const type in ret.data) {
            this.activityList[type] = ret.data[type]
          }
        })
      })

      getCacheConfig(comAuxiliary, 'randSpins', { class: 'randSpins', select: 0 }).then(res => {
        this.loading = false
        const data = res.data
        for (const i in data) {
          const val = data[i]
          for (const k in val) {
            this.randSpins.push({ label: val[k].name, value: parseInt(val[k].id) })
          }
        }
      })

      getCacheConfig(comAuxiliary, 'randMoney', { class: 'randMoney', select: 0 }).then(res => {
        this.loading = false
        const data = res.data
        for (const i in data) {
          const val = data[i]
          for (const k in val) {
            this.randMoney.push({ label: val[k].name, value: parseInt(val[k].id) })
          }
        }
      })

      getCacheConfig(comAuxiliary, 'randDiamond', { class: 'randDiamond', select: 0 }).then(res => {
        this.loading = false
        const data = res.data
        for (const i in data) {
          const val = data[i]
          for (const k in val) {
            this.randDiamond.push({ label: val[k].name, value: parseInt(val[k].id) })
          }
        }
      })

      getCacheConfig(comAuxiliary, 'randCooperativeCoin', { class: 'randCooperativeCoin', select: 0 }).then(res => {
        this.loading = false
        const data = res.data
        for (const i in data) {
          const val = data[i]
          for (const k in val) {
            this.randCooperativeCoin.push({ label: val[k].name, value: parseInt(val[k].id) })
          }
        }
      })
    },
    addReward() {
      const uniqueId = Date.now() + Math.random().toString(36).substr(2, 9)
      if (this.excludeCate.length > 0) {
        for (const i in this.propsOption) {
          const val = this.propsOption[i]
          for (const k in val.children) {
            const children = val.children[k]
            this.value.push({ uniqueId, propsId: children.value, num: 1, skin: 0, rtype: 0 })
            break
          }
          break
        }
      } else {
        this.value.push({ uniqueId, propsId: 15, num: 1, skin: 0, rtype: 0 })
      }
    },
    removeReward(zIndex) {
      this.value.splice(zIndex, 1)
    },
    propChange(v, i) {
      const reward = this.value[i]
      const propsId = parseInt(v)
      reward.num = 1
      reward.skin = 0
      reward.rtype = 0
      if (this.activityToTypeId.indexOf(propsId) > 0) {
        if (this.activityList[propsId].length > 0) {
          reward.skin = this.activityList[propsId][0].id
        }
      } else if (this.skinMap[propsId] != null && this.skinMap[propsId] !== undefined) {
        if (this.skinMap[propsId].length > 0) {
          reward.skin = this.skinMap[propsId][0].value
        }
      } else if (propsId === 14) {
        reward.rtype = 2
      } else if (propsId === 13) {
        reward.rtype = 1
      }
      this.value[i] = reward
    },
    handleShowDrawer() {
      this.showDrawer = true
    },
    handleShowReward(reward) {
      const str = []
      for (let i = 0; i < reward.length; i++) {
        const row = reward[i]
        if (row.propsId === '') {
          continue
        }
        if (this.activityToTypeId.indexOf(row.propsId) >= 0) {
          const name = this.handleShowActSkin(row.propsId, row.skin)
          str.push(this.activityToType[row.propsId] + '-' + name + ':' + row.num + '分钟')
        } else if (this.skinMap[row.propsId] != null && this.skinMap[row.propsId] !== undefined) {
          const name = this.handleShowRewardSkin(row.propsId, row.skin)
          str.push(this.rewardTypeMap[row.propsId] + '-' + name + ':' + row.num)
        } else if (row.propsId === 14) {
          const tmp = row.rtype === 2 ? '等级取值' : '只取数量'
          str.push(this.rewardTypeMap[row.propsId] + '-' + tmp + ':' + row.num)
        } else {
          str.push(this.rewardTypeMap[row.propsId] + ':' + row.num)
        }
      }
      return str.join(',')
    },
    handleShowRewardSkin(propsId, val) {
      for (let i = 0; i < this.skinMap[propsId].length; i++) {
        const row = this.skinMap[propsId][i]
        if (row.value === val) {
          return row.label
        }
      }
      return ''
    },
    handleShowActSkin(propsId, val) {
      if (this.activityList[propsId] != null && this.activityList[propsId] !== undefined) {
        for (let i = 0; i < this.activityList[propsId].length; i++) {
          const row = this.activityList[propsId][i]
          if (row.id === val) {
            return row.name
          }
        }
      }
      return ''
    },
    handleExtraValTitle(propsId) {
      if (this.activityToTypeId.indexOf(propsId) >= 0 || (this.skinMap[propsId] != null && this.skinMap[propsId] !== undefined)) {
        return '皮肤参数'
      } else if (propsId === 14) {
        return '金币取值'
      } else {
        return '扩展参数'
      }
    },
    tranToZH(reward) {
      const tmp = { propsId: '', num: '', val: '' }
      tmp.propsId = this.rewardTypeMap[reward.propsId] ?? 'UnKnow'
      tmp.num = reward.num
      let val = ''
      if (this.activityToTypeId.indexOf(reward.propsId) >= 0) {
        val = this.handleShowActSkin(reward.propsId, reward.skin)
      } else if (this.skinMap[reward.propsId] != null && this.skinMap[reward.propsId] !== undefined) {
        val = this.handleShowRewardSkin(reward.propsId, reward.skin)
      } else if (reward.propsId === 14) {
        val = reward.rtype === 2 ? '等级取值' : '只取数量'
      }
      tmp.val = val
      return tmp
    },
    tranToVal(reward) {
      const tmp = { propsId: 15, num: 1, skin: 0, rtype: 0 }
      tmp.num = reward.num
      for (const propsId in this.rewardTypeMap) {
        if (reward.propsId === this.rewardTypeMap[propsId]) {
          tmp.propsId = parseInt(propsId)
          break
        }
      }
      if (this.activityToTypeId.indexOf(tmp.propsId) >= 0) {
        if (this.activityList[tmp.propsId] != null && this.activityList[tmp.propsId] !== undefined) {
          for (let i = 0; i < this.activityList[tmp.propsId].length; i++) {
            if (reward.val === this.activityList[tmp.propsId][i].name) {
              tmp.skin = this.activityList[tmp.propsId][i].id
              break
            }
          }
        }
      } else if (this.skinMap[tmp.propsId] != null && this.skinMap[tmp.propsId] !== undefined) {
        for (let i = 0; i < this.skinMap[tmp.propsId].length; i++) {
          if (reward.val === this.skinMap[tmp.propsId][i].label) {
            tmp.skin = this.skinMap[tmp.propsId][i].value
            break
          }
        }
      } else if (tmp.propsId === 14) {
        tmp.rtype = reward.val === '等级取值' ? 2 : 1
      }
      return tmp
    },
    handleTranToZH(reward) {
      if (reward instanceof Array) {
        const out = []
        for (let i = 0; i < reward.length; i++) {
          out.push(this.tranToZH(reward[i]))
        }
        return out
      } else {
        return this.tranToZH(reward)
      }
    },
    handleTranToVal(reward) {
      if (reward instanceof Array) {
        const out = []
        for (let i = 0; i < reward.length; i++) {
          out.push(this.tranToVal(reward[i]))
        }
        return out
      } else {
        return this.tranToVal(reward)
      }
    }
  }
}
</script>
